module.exports = __webpack_public_path__ + "static/media/search.3dafc59a.svg";